import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AlphaChannel, OutputFormat} from "ngx-color-picker/lib/helpers";

@Component({
  selector: 'beaconstac-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {

  /**
   * Should button be disabled
   */
  @Input()
  disabled: boolean = false;

  /**
   * Button contents
   *
   * @required
   */
  @Input()
  label: boolean = false;

  /**
   * Color
   *
   * @required
   */
  @Input()
  color = '';
    
  /**
   * text-field disabled but clickable
   */
  @Input()
  readonly: boolean = false;

  /**
   * disable validator
   */
  @Input()
  disableValidator: boolean = false;

  /**
   * Color change
   *
   * @required
   */
  @Output()
  colorChange = new EventEmitter<Event>();

  /**
   * Button contents
   *
   * @required
   */
  @Input()
  title = 'Button';


  // [label]="true"
  //   [title]="'Eye-frame color'"

  /**
   * Optional click handler
   */
  @Output()
  colorPickerChange = new EventEmitter<Event>();

  @Input()
  id: string = '';

  @Input()
  width: string = '';

  @Input()
  cpOutputFormat: OutputFormat = 'hex';

  @Input()
  cpAlphaChannel: AlphaChannel = 'disabled';

  @Input()
  cpPosition: string = 'bottom';

  @Input()
  cpWidth: string = '';

  @Input()
  presetColors: any[] = [];

  @Input()
  enableAddColorBtn = false;

  @Output()
  presetColorChange: EventEmitter<any> =  new EventEmitter();

  toggleColorPicker() {
    document.getElementById(this.id).click();
  }

  colorPickerChanged(event) {
    this.colorPickerChange.next(event);
  }

  handlePresetColorChange(event) {
    this.presetColorChange.emit(event);
  }
}
